<nav class="breadcrumb-container" aria-label="Breadcrumb">
  <ol class="breadcrumb-list">
    @for (item of items(); track $index; let i = $index) {
      <li
        class="breadcrumb-item"
        [attr.data-active]="item.active || isLastItem(i)"
      >
        @if (showFirstItemIcon() && i === 0) {
          <span class="breadcrumb-icon">
            <umss-icon [name]="firstItemIconName()" size="16px"></umss-icon>
          </span>
        } @else if (item.iconName) {
          <span class="breadcrumb-icon">
            <umss-icon [name]="item.iconName" size="16px"></umss-icon>
          </span>
        }

        @if (!item.active && !isLastItem(i) && item.url) {
          <a
            [routerLink]="item.url"
            [queryParams]="item.queryParams ?? null"
            class="breadcrumb-link"
            (click)="onItemClick(item, $event)"
          >
            {{ item.label }}
          </a>
        } @else if (!item.active && !isLastItem(i) && !item.url) {
          <button
            type="button"
            class="breadcrumb-button"
            (click)="onItemClick(item, $event)"
          >
            {{ item.label }}
          </button>
        } @else {
          <span class="breadcrumb-current" aria-current="location">
            {{ item.label }}
          </span>
        }

        @if (!isLastItem(i)) {
          <span class="breadcrumb-separator" aria-hidden="true">
            {{ separator() }}
          </span>
        }
      </li>
    }
  </ol>
</nav>
